import {
  apiRequest,
  P3KuploadSKP3K,
  P3KdetailP3K,
} from "../../../../../services/adapters/kepegawaian/P3KService";

class DetailRepository {
  fetchUploadSk = async (query) => {
    return await apiRequest(
      "post",
      P3KuploadSKP3K,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      P3KdetailP3K,
      {
        params: query,
      },
      true
    );
  };
}

export default DetailRepository;
